// extracted by mini-css-extract-plugin
module.exports = {"section":"indexedSection_section__f75lW","avatar":"indexedSection_avatar__FeFJQ","list":"indexedSection_list__1QqVl"};